module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_VIII"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "I9780062322470_Contents_toc_4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062322470_Dedication#r9780062322470_Contents_toc_4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("DEDICATION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "repi"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062322470_Front_Matter#epi",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("EPIGRAPH")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    staticStyle: {
      "margin-bottom": "1em"
    },
    attrs: {
      "id": "I9780062322470_Contents_toc_5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062322470_Acknowledgement#r9780062322470_Contents_toc_5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ACKNOWLEDGMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "I9780062322470_Contents_toc_6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062322470_Part_1#r9780062322470_Contents_toc_6"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART ONE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1",
    attrs: {
      "id": "I9780062322470_Contents_toc_7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062322470_Chapter_1#r9780062322470_Contents_toc_7"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ONE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1",
    attrs: {
      "id": "I9780062322470_Contents_toc_8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062322470_Chapter_2#r9780062322470_Contents_toc_8"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("TWO")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1",
    attrs: {
      "id": "I9780062322470_Contents_toc_9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062322470_Chapter_3#r9780062322470_Contents_toc_9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("THREE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1",
    attrs: {
      "id": "I9780062322470_Contents_toc_10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062322470_Chapter_4#r9780062322470_Contents_toc_10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("FOUR")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1",
    attrs: {
      "id": "I9780062322470_Contents_toc_11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062322470_Chapter_5#r9780062322470_Contents_toc_11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("FIVE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-2",
    attrs: {
      "id": "I9780062322470_Contents_toc_12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062322470_Chapter_6#r9780062322470_Contents_toc_12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("SIX")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "I9780062322470_Contents_toc_13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062322470_Part_2#r9780062322470_Contents_toc_13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART TWO")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1",
    attrs: {
      "id": "I9780062322470_Contents_toc_14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062322470_Chapter_7#r9780062322470_Contents_toc_14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("SEVEN")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1",
    attrs: {
      "id": "I9780062322470_Contents_toc_15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062322470_Chapter_8#r9780062322470_Contents_toc_15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("EIGHT")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1",
    attrs: {
      "id": "I9780062322470_Contents_toc_16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062322470_Chapter_9#r9780062322470_Contents_toc_16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NINE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1",
    attrs: {
      "id": "I9780062322470_Contents_toc_17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062322470_Chapter_10#r9780062322470_Contents_toc_17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("TEN")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-2",
    attrs: {
      "id": "I9780062322470_Contents_toc_18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062322470_Chapter_11#r9780062322470_Contents_toc_18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ELEVEN")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "I9780062322470_Contents_toc_19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062322470_Part_3#r9780062322470_Contents_toc_19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART THREE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1",
    attrs: {
      "id": "I9780062322470_Contents_toc_20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062322470_Chapter_12#r9780062322470_Contents_toc_20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("TWELVE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1",
    attrs: {
      "id": "I9780062322470_Contents_toc_21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062322470_Chapter_13#r9780062322470_Contents_toc_21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("THIRTEEN")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1",
    attrs: {
      "id": "I9780062322470_Contents_toc_22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062322470_Chapter_14#r9780062322470_Contents_toc_22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("FOURTEEN")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1",
    attrs: {
      "id": "I9780062322470_Contents_toc_23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062322470_Chapter_15#r9780062322470_Contents_toc_23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("FIFTEEN")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-2",
    attrs: {
      "id": "I9780062322470_Contents_toc_24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062322470_Chapter_16#r9780062322470_Contents_toc_24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("SIXTEEN")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "I9780062322470_Contents_toc_25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062322470_Part_4#r9780062322470_Contents_toc_25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART FOUR")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1",
    attrs: {
      "id": "I9780062322470_Contents_toc_26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062322470_Chapter_17#r9780062322470_Contents_toc_26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("SEVENTEEN")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1",
    attrs: {
      "id": "I9780062322470_Contents_toc_27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062322470_Chapter_18#r9780062322470_Contents_toc_27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("EIGHTEEN")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1",
    attrs: {
      "id": "I9780062322470_Contents_toc_28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062322470_Chapter_19#r9780062322470_Contents_toc_28",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NINETEEN")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1",
    attrs: {
      "id": "I9780062322470_Contents_toc_29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062322470_Chapter_20#r9780062322470_Contents_toc_29",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("TWENTY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1",
    attrs: {
      "id": "I9780062322470_Contents_toc_30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062322470_Chapter_21#r9780062322470_Contents_toc_30",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("TWENTY-ONE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1",
    attrs: {
      "id": "I9780062322470_Contents_toc_31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062322470_Chapter_22#r9780062322470_Contents_toc_31",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("TWENTY-TWO")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1",
    attrs: {
      "id": "I9780062322470_Contents_toc_32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062322470_Chapter_23#r9780062322470_Contents_toc_32",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("TWENTY-THREE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-2",
    attrs: {
      "id": "I9780062322470_Contents_toc_33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062322470_Chapter_24#r9780062322470_Contents_toc_33",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("TWENTY-FOUR")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rata"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/About_the_Author#ata",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ABOUT THE AUTHOR")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "I9780062322470_Contents_toc_1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062322470_Back_Matter#r9780062322470_Contents_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PRAISE FOR WHAT HAPPENED TO SOPHIE WILDER")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "I9780062322470_Contents_toc_2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062322470_Also_by_Author#r9780062322470_Contents_toc_2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ALSO BY CHRISTOPHER BEHA")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rcre"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062322470_Credits#cre",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CREDITS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "I9780062322470_Contents_toc_3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062322470_Copyright#r9780062322470_Contents_toc_3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("COPYRIGHT")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "I9780062322470_Contents_toc_34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/About_the_Publisher#r9780062322470_Contents_toc_34",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ABOUT THE PUBLISHER")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40504d24","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062322470_Contents.vue
// module id = 72
// module chunks = 0